import { useMutation, useQueryClient } from "@tanstack/react-query";
import { invalidateSocialGraph } from "Api/Mutations/Social/invalidateSocialGraph";
import { deleteSocialFollowRequestsRequesterIdentityUserPublicID } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Translations/Resources";
import { toast } from "sonner";

/** Deletes a pending follow request addressed to the caller (silent — the requester may ask again). */
export const useDeleteFollowRequestMutation = () => {
  const queryClient = useQueryClient();
  const { t } = useResource();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      (requesterIdentityUserPublicID: string) =>
        deleteSocialFollowRequestsRequesterIdentityUserPublicID(
          requesterIdentityUserPublicID,
        ),
    ),
    onSuccess: () => invalidateSocialGraph(queryClient),
    onError: () => toast.error(t(Resources.Errors.RequestError)),
  });
};
